import type { AxiosError } from "axios";

export class ApiError extends Error {
  status?: number;
  code?: string;

  constructor(axiosError: AxiosError) {
    super(axiosError.message);
    this.name = "ApiError";
    this.status = axiosError.response?.status;
    this.message = (axiosError.response?.data as { message: string })?.message;
    this.code = axiosError.code;
  }
}
